import React, { createContext, useContext } from 'react';
interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
}
const TabsContext = createContext<{
  value: string;
  onValueChange: (v: string) => void;
} | null>(null);
export function TabsRoot({
  value,
  onValueChange,
  children
}: TabsProps) {
  return <TabsContext.Provider value={{
    value,
    onValueChange
  }} data-id="element-1268">
      <div className="w-full" data-id="element-1269">{children}</div>
    </TabsContext.Provider>;
}
export function TabsList({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`inline-flex h-12 items-center justify-center rounded-full bg-[#F7F7FA] p-1 border border-[#E8E8ED] ${className || ''}`} data-id="element-1270">
      {children}
    </div>;
}
export function TabsTrigger({
  value,
  children,
  className
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
}) {
  const context = useContext(TabsContext);
  if (!context) return null;
  const isActive = context.value === value;
  return <button onClick={() => context.onValueChange(value)} className={`
        inline-flex items-center justify-center whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-all duration-200
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FC4C02] disabled:pointer-events-none disabled:opacity-50
        ${isActive ? 'bg-white text-[#2D2D2D] shadow-sm' : 'text-[#6B6B76] hover:text-[#2D2D2D]'}
        ${className || ''}
      `} data-id="element-1271">
      {children}
    </button>;
}
export function TabsContent({
  value,
  children,
  className
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
}) {
  const context = useContext(TabsContext);
  if (!context || context.value !== value) return null;
  return <div className={`mt-6 ${className || ''}`} data-id="element-1272">{children}</div>;
}
export function Tabs({
  value,
  onValueChange,
  children
}: TabsProps) {
  return <TabsRoot value={value} onValueChange={onValueChange} data-id="element-1273">
      {children}
    </TabsRoot>;
}